import { FileKind } from "../../../../define/FileKind";
import { BaseLocalListData } from "../../base/BaseLocalListData";

/** 妻子数据 */
class WifeInfo{
    /** id */
    id: string = '';
    /** 状态 */
    state: number = 0;
    /** 亲密度 */
    intimacy: number = 0;
    /** 是否新人 */
    bNew: boolean = true;
    /** 是否放入府里 */
    bEnterMansion: boolean = false;
    /** 最后侍寝时间 */
    lastServantDate: number = 0;
    /** 是否已怀孕 */
    bFetation: boolean = false;

    resetStateData() {
        this.intimacy = 0;
        this.bNew = true;
        this.bEnterMansion = false;
        this.lastServantDate = 0;
        this.bFetation = false;
    }
}

export default class WifeData extends BaseLocalListData {
    lists = new Map<string, WifeInfo>();

    protected localKey: string = FileKind.SaveLocalDataKey.WIFE_DATA;

    createItem(key: string): WifeInfo {
        return this.createItemT<WifeInfo>(WifeInfo, key);
    }

    isOwnWife(name: string, state: number, bAjState: boolean = true) {
        let arrKeys = Array.from(this.lists.keys());

        for(let o of arrKeys) {
            let item = this.lists.get(o);
            if (item.id == name) {
                if (bAjState) {
                    if (item.state == state) {
                        return true;
                    }
                } else {
                    return  true;
                }
                break;
            }
        }
        return false;
    }
}
